<script>
import { check } from "../utils/auth";
export default {
  functional: true,
  props: {
    authority: Array
    // required: true
  },
  render(h, context) {
    const { props, scopedSlots } = context;
    return check(props.authority) ? scopedSlots.default() : null;
  }
};
</script>
